import React from 'react';

function CategorySelector({ categories, currentCategory, onCategoryChange }) {
  const getCategoryClass = (categoryName) => {
    if (currentCategory === categoryName) {
      // Используем разные классы для разных категорий
      if (categoryName === 'hdmo') return 'hd-on';
      if (categoryName === 'pcmo') return 'pc-on';
      return 'hd-on'; // default active class
    }
    return '';
  };

  return (
    <div className="cat">
      {categories.map((category) => (
        <button 
          key={category.name}
          className={getCategoryClass(category.name)}
          onClick={() => onCategoryChange(category.name)}
        >
          {category.display_name}
        </button>
      ))}
    </div>
  );
}

export default CategorySelector;
